import { useEffect, useState } from 'react';
import { Navigation, Clock, PackageCheck } from 'lucide-react';
import { api } from '../lib/api';
import { MapView } from './MapView';

const ago = (iso) => { if (!iso) return ''; const s = Math.max(0, (Date.now() - new Date(iso).getTime()) / 1000); return s < 60 ? `il y a ${Math.round(s)} s` : s < 3600 ? `il y a ${Math.round(s / 60)} min` : `il y a ${Math.round(s / 3600)} h`; };

export function DeliveryTracker({ orderId, compact = false }) {
  const [t, setT] = useState(null);
  useEffect(() => {
    let alive = true;
    const load = () => api.get(`/orders/${orderId}/tracking`).then(({ data }) => alive && setT(data)).catch(() => {});
    load(); const id = setInterval(load, 5000);
    return () => { alive = false; clearInterval(id); };
  }, [orderId]);
  if (!t) return <div className="h-40 rounded-2xl glass animate-pulse" data-testid={`tracker-loading-${orderId}`} />;
  const dest = t.delivery?.lat != null ? [t.delivery.lat, t.delivery.lng] : null;
  const courier = t.courier_location ? [t.courier_location.lat, t.courier_location.lng] : null;
  const shop = t.shop?.lat != null ? [t.shop.lat, t.shop.lng] : null;
  const markers = [
    dest && { key: 'dest', pos: dest, icon: 'home', label: `Livraison : ${t.delivery.address}` },
    courier && { key: 'courier', pos: courier, icon: 'courier', label: `Livreur · ${ago(t.courier_location.at)}` },
    shop && !courier && { key: 'shop', pos: shop, icon: 'shop', label: t.shop.name },
  ].filter(Boolean);
  const live = courier && Date.now() - new Date(t.courier_location.at).getTime() < 120000;
  return (
    <div className="space-y-3" data-testid={`tracker-${orderId}`}>
      <div className="flex flex-wrap items-center justify-between gap-2">
        <div className="flex items-center gap-2 text-sm">
          {live ? <><span className="h-2 w-2 rounded-full bg-[#E8B84A] animate-pulse" /><span className="gold-text font-bold">Livreur en direct</span><span className="text-slate-500 text-xs">· {ago(t.courier_location.at)}</span></>
            : courier ? <><Clock className="h-4 w-4 text-slate-400" /><span className="text-slate-300">Dernière position {ago(t.courier_location.at)}</span></>
            : t.status === 'delivered' ? <><PackageCheck className="h-4 w-4 text-sky-400" /><span className="text-slate-300">Livrée</span></>
            : <><Navigation className="h-4 w-4 text-slate-400" /><span className="text-slate-400">En attente de la position du livreur…</span></>}
        </div>
        {t.shipping_note && <div className="text-xs text-[#F5D98B]/90 glass-gold rounded-full px-3 py-1" data-testid={`tracker-note-${orderId}`}>{t.shipping_note}</div>}
      </div>
      {markers.length > 0 ? <MapView markers={markers} trail={t.courier_trail || []} height={compact ? 'h-48' : 'h-72'} testid={`tracker-map-${orderId}`} />
        : <div className="h-28 rounded-2xl glass grid place-items-center text-xs text-slate-500 text-center px-4">Aucune position GPS pour cette commande. L'acheteur peut utiliser « Ma position » au moment de la commande.</div>}
    </div>
  );
}
